import React, { useEffect, useState } from "react";
import { Row } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Button, Select } from "components";
import { localStorageHelper } from "utils/localstorage";
import { FirstSectionActionCreators } from "redux/rootActions";
import { departmentList4DashboardDataResponse } from "redux/dashboard/departmentList/departmentListStates";
import { firstSectionDataResponse } from "redux/dashboard/firstSection/firstSectionStates";
import { httpStatus } from "configs/httpStatus";
import {
  PhysicalDisorder,
  MentalDisorder,
  DisorderStatistical,
} from "./charts";
import { WrapperPhysicalAction, GroupSelect } from "./Dashboard.style";

const currentYear = moment().year();

const PhysicalSection = () => {
  const currentLanguage = localStorageHelper.getItem("i18nextLng");
  const { t } = useTranslation("translation", {
    keyPrefix: "account",
  });
  const { t: t1 } = useTranslation("translation", {
    keyPrefix: "dashboard",
  });

  const dispatch = useDispatch();
  const departmentList4DashboardData = useSelector(
    departmentList4DashboardDataResponse
  );
  const firstSectionData = useSelector(firstSectionDataResponse);

  const [departmentListOptions, setDepartmentListOptions] = useState<any>([]);
  const [firstSectionPayload, setFirstSectionPayload] = useState<any>({
    designation_id: "",
    year: currentYear,
    month: moment().month() + 1,
  });
  const [data, setData] = useState<any>({
    mental_illness: {},
    physical_disorder: {},
    health_status_table_data: [],
  });

  const year: any = [];
  for (let i = 2000; i <= currentYear; i++) {
    year.push({
      id: i,
      name: `${i}${currentLanguage === "ja" ? "年" : " "}`,
      value: i,
    });
  }

  const month: any = [];
  for (let i = 1; i <= 12; i++) {
    if (i <= 9) {
      month.push({
        id: i,
        name: `0${i}${currentLanguage === "ja" ? "月" : " "}`,
        value: i,
      });
    } else {
      month.push({
        id: i,
        name: `${i}${currentLanguage === "ja" ? "月" : " "}`,
        value: i,
      });
    }
  }

  useEffect(() => {
    if (
      departmentList4DashboardData &&
      departmentList4DashboardData.status === httpStatus.StatusOK
    ) {
      setDepartmentListOptions([
        {
          id: "0",
          name: t1("entire-company"),
          value: "",
        },
        ...departmentList4DashboardData.result.map((item: any) => {
          return {
            id: item.id,
            name: item.name,
            value: item.id,
          };
        }),
      ]);
    }
  }, [departmentList4DashboardData]);

  useEffect(() => {
    if (firstSectionData && firstSectionData.status === httpStatus.StatusOK) {
      setData(firstSectionData.result);
    }
  }, [firstSectionData]);

  const handleOnChangeDepartmentList = (value: number) => {
    setFirstSectionPayload((prevState: any) => ({
      ...prevState,
      designation_id: value,
    }));
  };

  const handleOnChangeYear = (value: number) => {
    setFirstSectionPayload((prevState: any) => ({
      ...prevState,
      year: value,
    }));
  };

  const handleOnChangeMonth = (value: number) => {
    setFirstSectionPayload((prevState: any) => ({
      ...prevState,
      month: value,
    }));
  };

  useEffect(() => {
    dispatch(
      FirstSectionActionCreators.getFirstSectionDataAction(firstSectionPayload)
    );
  }, []);

  return (
    <React.Fragment>
      <WrapperPhysicalAction>
        <GroupSelect>
          <Select
            width="100px"
            options={departmentListOptions}
            onChange={handleOnChangeDepartmentList}
            placeholder={t1("entire-company")}
            value={firstSectionPayload.designation_id}
          />
          <Select
            width="100px"
            options={year}
            onChange={handleOnChangeYear}
            value={firstSectionPayload.year}
          />
          <Select
            width="82px"
            options={month}
            onChange={handleOnChangeMonth}
            value={firstSectionPayload.month}
          />
        </GroupSelect>
        <Button
          name={t("update")}
          background="#2AC769"
          color="#FFFFFF"
          border="none"
          fontSize={16}
          fontWeight={700}
          onClick={() => {
            dispatch(
              FirstSectionActionCreators.getFirstSectionDataAction(
                firstSectionPayload
              )
            );
          }}
        />
      </WrapperPhysicalAction>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <PhysicalDisorder data={data.mental_illness} />
        <MentalDisorder data={data.physical_disorder} />
        <DisorderStatistical data={data.health_status_table_data} />
      </Row>
    </React.Fragment>
  );
};

export default PhysicalSection;
